import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { KnowledgeItem } from "@/hooks/knowledge/useKnowledgeItems";
import EditLinkForm from "./forms/EditLinkForm";

interface EditLinkDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    item: KnowledgeItem;
    onSuccess?: (item?: KnowledgeItem) => void;
}

const EditLinkDialog = ({
    open,
    onOpenChange,
    item,
    onSuccess
}: EditLinkDialogProps) => {
    const handleSuccess = (updatedItem?: KnowledgeItem) => {
        if (onSuccess) {
            onSuccess(updatedItem);
        } else {
            onOpenChange(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[600px]">
                <DialogHeader>
                    <DialogTitle>Link information</DialogTitle>
                </DialogHeader>
                <EditLinkForm item={item} onSuccess={handleSuccess} />
            </DialogContent>
        </Dialog>
    );
};

export default EditLinkDialog; 